export default __webpack_public_path__ + "media/images/logo-5b65ec48afdf88113eb03d2a1d48b6fe.png";